module.exports = __webpack_public_path__ + "img/max-file-content-edit.24b93e18.svg";